module.exports = __webpack_public_path__ + "img/gold-coast.1b8f654c.png";